import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/tailwindcss.css'
import './assets/font/YouSheBiaoTiHei.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.prototype.$echarts = echarts
//图标刷新间隔时间
Vue.prototype.$intervalRefreshDate = 6000000

import alertModal from './components/alertModal/alertModal.js'
Vue.use(alertModal)
Vue.use(ElementUI);

Vue.config.productionTip = false





new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
